/* Lucky Kiddo: plavajoč gumb "Filter" (mobilno). Ob kliku sproži klik na originalni gumb v vrstici filtrov. */
(function () {
  var SEL = '.cloud-search-page-controls__filters-link';
  var fab = null, queued = false;

  function build(link) {
    var label = (link.textContent || 'Filter').trim() || 'Filter';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lk-filter-fab';
    b.setAttribute('aria-label', label);

    var i = document.createElement('span');
    i.className = 'lk-filter-fab__icon';
    var src = link.querySelector('.cloud-search-filters-link-icon');
    if (src) {
      var bg = getComputedStyle(src).backgroundImage;
      if (bg && bg !== 'none') i.style.backgroundImage = bg;
    }

    var t = document.createElement('span');
    t.className = 'lk-filter-fab__text';
    t.textContent = label;

    b.appendChild(i);
    b.appendChild(t);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var l = document.querySelector(SEL);
      if (l) l.click();
    });
    document.body.appendChild(b);
    return b;
  }

  function sync() {
    queued = false;
    var link = document.querySelector(SEL);
    if (link && !fab) fab = build(link);
    else if (!link && fab) { fab.remove(); fab = null; }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  sync();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();
